import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

const useLiveDate = (startAt?: number) => {
  const { lang } = useParams()

  const liveDate = useMemo(() => {
    if (!startAt) return undefined

    const date = new Date(startAt)

    const fmtDate = date
      .toLocaleDateString(lang, {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      })
      ?.replace(/\./g, '')

    const time = date.toLocaleTimeString(lang, {
      hour: '2-digit',
      minute: '2-digit'
    })

    return `${fmtDate} - ${time}`
  }, [startAt])

  return liveDate
}

export default useLiveDate
